module.exports = __webpack_public_path__ + "static/media/article10.6b7ba832.webp";